import React, { useEffect, useState } from "react";
import parse from "html-react-parser";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { FadeLoader } from "react-spinners";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";

const PAGE_ID = 772;

const StudentiRezija = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const { t } = useTranslation();
  const storedLanguage = localStorage.getItem("selectedLanguage");

  useEffect(() => {
    setLoading(true);
    setError(false);

    axios
      .get("https://www.asu.unsa.ba/v2/index.php", {
        params: {
          rest_route: `/wp/v2/pages/${PAGE_ID}`,
          _fields: "id,title,content,acf",
          acf_format: "standard",
        },
      })
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        console.error("API error:", err);
        setError(true);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div
        className="text-center"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "70vh",
        }}
      >
        <FadeLoader color="#123abc" loading={loading} />
      </div>
    );
  }

  if (error || !data) {
    return <p style={{ padding: 20 }}>Podaci nisu dostupni.</p>;
  }

  const naslov =
    storedLanguage === "en"
      ? data?.acf?.prevod_naslova || data?.title?.rendered || ""
      : data?.title?.rendered || "";

  const opis =
    storedLanguage === "en"
      ? data?.acf?.prevod_teksta || data?.content?.rendered || ""
      : data?.content?.rendered || "";

  const prikaziOpis = parse(opis || "", {
    replace: (domNode) => {
      const href = domNode?.attribs?.href;

      if (
        domNode?.name === "a" &&
        href &&
        href.toLowerCase().endsWith(".pdf")
      ) {
        return (
          <a href={href} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faFilePdf} style={{ marginRight: 6 }} />
            {domNode?.children?.[0]?.data || "PDF"}
          </a>
        );
      }

      return null;
    },
  });

  return (
    <div className="container drugaSekcija dekanat">
      <div className="container dekanat">
        <h1>STUDENTI | {naslov ? parse(naslov) : ""}</h1>

        <div className="container drugaSekcija">
          <div className="d-flex bd-highlight">
            <div className="p-2 flex-fill bd-highlight">{prikaziOpis}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentiRezija;
